export default {
  mimeTypeSettingsHeader: '{mimeType} Einstellungen',
  contentTypeSettingsHeader: 'Content Einstellungen',
  title: '{mimeType} exportieren',
  submitLabel: '{mimeType} exportieren',
};
